import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup'
import Alert from 'react-bootstrap/Alert'
import { Columns } from 'react-bootstrap-icons';
import { findFirstItemMatchesCondition } from '@devexpress/analytics-core/analytics-internal';
import * as MySound from '../MySound';

export class AssignLocations extends Component {
    static displayName = AssignLocations.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedShipment: props.location.state.selectedShipment,
            devanlocations: [],
            toggleAssignLocationToOrder: false,
            selectedOrder: null,
            alertMessage: "",
            locationBarcode: ""

        };
        this.history = props.history;

    }
    componentDidMount() {
        this.getStoreLocations();
    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }
    render() {
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const handleScanInput = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.assignLocationToOrder(e.target.value);
            }
        };
        //TODO: toggle function to when assigning new location to the order
        var parent = this;
        return (
            <>
                <h4>Assign Locations</h4>
                {this.state.alertMessage.length > 0 && <Alert variant="danger">
                    {this.state.alertMessage}
                </Alert>}
                {!this.state.toggleAssignLocationToOrder && <>
                    {this.state.devanlocations.map(function (item, index) {
                        var child = parent;
                        return (<ListGroup.Item key={index}>
                            <Row>
                                <Col><b>{item.client_order_no}</b> <br></br> {item.xdoc_location}</Col>
                                <Col><Button variant="success" onClick={() => child.setState({ selectedOrder: item, toggleAssignLocationToOrder: true, locationBarcode: "" })}>New Location</Button></Col>
                            </Row>
                        </ListGroup.Item>);
                    })}
                    <Row>
                        <Col>
                            <Button className="col-6 float-left mt-2" variant="danger" onClick={() => this.goto('MXDockChooseShipment', null)}>Back</Button>
                        </Col>
                        <Col>
                            <Button className="col-6 float-right mt-2" variant="success" onClick={() => this.checkOrderLocations()}>Done</Button>
                        </Col>
                    </Row></>
                }
                {this.state.toggleAssignLocationToOrder && <>
                    <Row className="mt-2"><Col>Assign new location to order {this.state.selectedOrder.client_order_no}</Col></Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            Prev. Location:
                        </Col>
                        <Col className="col-8">
                            {this.state.selectedOrder.xdoc_location}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            New Location:
                        </Col>
                        <Col className="col-8">
                            <input autoFocus="autofocus" className="filter form-control" onKeyPress={handleScanInput} type="text" placeholder="Scan location..."
                                value={this.state.locationBarcode}
                                ref="newLocationScanInput"
                                onChange={(e) => {
                                    this.setState({ locationBarcode: e.target.value });
                                }}
                                onKeyPress={(e) => {
                                    if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                                        this.assignLocationToOrder(this.state.locationBarcode);
                                    }
                                }}
                                onInput={toInputUppercase} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="col-6 float-left mt-2" variant="danger" onClick={() => this.setState({ toggleAssignLocationToOrder: false, alertMessage: "" })}>Cancel</Button>
                        </Col>
                        <Col>
                            <Button className="col-6 float-right mt-2" variant="success" onClick={() => this.assignLocationToOrder(this.state.locationBarcode)}>Assign</Button>
                        </Col>
                    </Row></>
                }
            </>
        );
    }

    checkOrderLocations() {
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.selectedShipment)
        };
        fetch('api/MXDock/ValidateShipmentOrderLocations', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                        this.goto('ScanCarton', { selectedShipment: this.state.selectedShipment });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    assignLocationToOrder(newLocation) {
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Shipment: this.state.selectedShipment, Location: this.state.selectedOrder, NewLocationId: newLocation })
        };
        fetch('api/MXDock/AssignNewLocation', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        var tempOrder = this.state.selectedOrder;
                        tempOrder.xdoc_location = newLocation;
                        this.setState({ loading: false, alertMessage: "", selectedOrder: tempOrder, toggleAssignLocationToOrder: false });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                        this.refs.newLocationScanInput.focus();
                        this.refs.newLocationScanInput.select();
                        MySound.play(MySound.Sound.stop);
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    async getStoreLocations() {
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.selectedShipment)
        };
        fetch('api/MXDock/GetShipmentDevanLocations', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", devanlocations: result.data });
                    }
                    else {
                        this.setState({ alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
}
export default AssignLocations;

